/**
 * 获取 React 组件实例的名字
 * @param instance React.instance
 */
export function getInstanceName(instance) {
  if (!instance) {
    return null;
  }

  var type = instance.type;
  var constructor = instance.constructor;
  return (// @ts-ignore
    type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null
  );
}
export default {
  getInstanceName: getInstanceName
};